import React, { useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
export function FilterBar() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const categories = ['全部', '欧美女郎', '日韩女郎', '越南女郎', '中国女郎', '东南亚女郎', '混血女郎'];
  return <div className="sticky top-[72px] z-40 bg-dark-900/95 backdrop-blur border-b border-white/5 py-4" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-121">
          {/* Categories - Horizontal Scroll */}
          <div className="flex-1 overflow-x-auto pb-2 md:pb-0 hide-scrollbar" data-id="element-122">
            <div className="flex space-x-2 min-w-max" data-id="element-123">
              {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm transition-all duration-300 whitespace-nowrap ${activeCategory === category ? 'bg-gold-500 text-dark-900 font-medium' : 'bg-dark-800 text-gray-400 hover:text-gold-500 hover:border-gold-500 border border-transparent'}`} data-id="element-124">
                  {category}
                </button>)}
            </div>
          </div>

          {/* Sort & Filter Button */}
          <div className="flex items-center justify-between md:justify-end gap-4 border-t border-white/5 pt-4 md:pt-0 md:border-t-0" data-id="element-125">
            <div className="flex items-center text-sm text-gray-400" data-id="element-126">
              <span className="mr-2" data-id="element-127">排序:</span>
              <select className="bg-transparent border-none text-white focus:ring-0 cursor-pointer text-sm p-0" data-id="element-128">
                <option className="bg-dark-800" data-id="element-129">推荐</option>
                <option className="bg-dark-800" data-id="element-130">最新</option>
                <option className="bg-dark-800" data-id="element-131">价格: 低到高</option>
                <option className="bg-dark-800" data-id="element-132">价格: 高到低</option>
              </select>
            </div>

            <button className="flex items-center text-sm text-gold-500 hover:text-white transition-colors" data-id="element-133">
              <SlidersHorizontal className="w-4 h-4 mr-2" data-id="element-134" />
              筛选
            </button>
          </div>
        </div>
      </div>
    </div>;
}